interface EventSubscription {
  id: string;
  count: number;
}

const methodSubscriptions: Map<string, string[]> = new Map();
const eventSubscriptions: Map<string, EventSubscription> = new Map();

const getDomainServiceName = (domain: string, serviceName: string): string => `${domain}-${serviceName}`;

export function addMethodSubscriptions(domain: string, serviceName: string, addMethodsCallback: () => string[]): void {
  const key = getDomainServiceName(domain, serviceName);
  const subscriptionIds = addMethodsCallback();
  methodSubscriptions.set(key, subscriptionIds);
}

export function removeMethodSubscriptions(
  domain: string,
  serviceName: string,
  removeMethodsCallback: (id: string) => void
): void {
  const key = getDomainServiceName(domain, serviceName);
  const subscriptionIds = methodSubscriptions.get(key) || [];
  subscriptionIds.forEach(removeMethodsCallback);
  methodSubscriptions.delete(key);
}

export function addEventSubscription(topic: string, addEventCallback: () => string) {
  const eventSubscription = eventSubscriptions.get(topic);

  if (eventSubscription) {
    eventSubscription.count += 1;
  } else {
    const id = addEventCallback();
    eventSubscriptions.set(topic, { id, count: 1 });
  }
}

export function removeEventSubscription(topic: string, removeEventCallback: (id: string) => void): void {
  const subscription = eventSubscriptions.get(topic);

  if (subscription) {
    subscription.count -= 1;

    if (subscription.count === 0) {
      eventSubscriptions.delete(topic);
      removeEventCallback(subscription.id);
    }
  }
}
